import * as types from 'store/modules/hres6eu/mutation-types'
import hres6eu from 'api/hres6eu'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hres6euLabels from 'assets/labels/hres6eu'
import { hres6euMaxRowspan, hres6euColumns } from 'assets/columns/hres6eu'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres6euLabels,
    maxRowspan: hres6euMaxRowspan,
    columns: hres6euColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {}
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES6EU_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES6EU_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES6EU_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES6EU_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES6EU_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES6EU_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES6EU_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES6EU_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES6EU_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES6EU_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES6EU_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES6EU_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRES6EU_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES6EU_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES6EU_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES6EU_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES6EU_INDEX_DISP, indexDisp)
      commit(types.SET_HRES6EU_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES6EU_COLUMNS_LABELS] ({ commit }) {
      hres6eu.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6EU_COLUMNS, data.labels)
          commit(types.SET_HRES6EU_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6EU_INDEX] ({ commit }, searchParams) {
      hres6eu.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6EU_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES6EU_DETAIL] ({ commit }, searchParams) {
      hres6eu.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES6EU_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES6EU_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres6eu.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES6EU_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6eu/index.js